/**
 * 使用方法举例
 * import validate from validate.js
 * validate.isPhoneNumber('19129321') // false
 * validate.isPhoneNumber('138001380000') // true
 */
export const validate = {
  /**
     * 纯数字及范围校验
     * @param {*} value
     * @param {number} start 最小值
     * @param {number} end 最大值
     */
  numberLimit (value, start = 0, end = 10000, point = 0) {
    if (value === '') {
      return false
    }
    if (point === 0) {
      if (value.toString().indexOf('.') < 0) {
        return /\d$/.test(value) && value >= start && value <= end
      } else {
        return false
      }
    } else {
      if (value.toString().indexOf('.') < 0) {
        return /\d$/.test(value) && value >= start && value <= end
      } else {
        var re = new RegExp(
          '^(?!0+(?:\\.0+)?$)(?:[1-9]\\d*|0)(?:\\.\\d{1,' + point + '})?$',
          'gim'
        )
        return (
          re.test(value) &&
            Math.floor(value) >= start &&
            Math.ceil(value) <= end
        )
      }
    }
  },
  /**
     * 手机号校验
     * @param {*} value
     */
  isPhoneNumber (value) {
    return /^1\d{10}$/.test(value)
  },
  /**
     * 致远电子验证码格式校验（致远电子的验证码为6位的数字）
     * @param {*} value
     */
  isVerifyCode (value) {
    return /\d{6}$/.test(value)
  },
  /**
     * 用户名格式校验（1-32位，只可以包含字母数字下划线,子用户名需包含@）
     * @param {*} value
     */
  isUsername (value) {
    return /^[a-zA-Z0-9_]|@{1,32}$/.test(value)
  },
  /**
     * 密码格式校验（8-16位，支持大、小写字母+数字+特殊符号，至少包含其中两种）
     * @param {*} value
     */
  isPassword (value) {
    // 首先检查长度是否为8-16位且不包含空格
    if (!/^\S{8,16}$/.test(value)) {
      return false;
    }

    // 定义不同类型的字符
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumbers = /[0-9]/.test(value);
    const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(value);

    // 计算符合条件的字符类型数量
    let charTypeCount = 0;
    if (hasUpperCase) charTypeCount++;
    if (hasLowerCase) charTypeCount++;
    if (hasNumbers) charTypeCount++;
    if (hasSpecialChars) charTypeCount++;

    // 至少包含两种字符类型
    return charTypeCount >= 2;
  },
  /**
     * 邮箱格式校验码
     * @param {*} value
     */
  isEmail (value) {
    return /^(\w)+((\.||\-)*\w+)*@(\w)+((\.||\-)*\w+)*((\.\w{2,3}){1,3})$/.test(value)
  },
  /**
     * 十六进制校验
     * @param {*} value
     */
  isHex (value, length) {
    return /^[A-Fa-f0-9]+$/.test(value)
  },
  /**
     * 设备名格式校验（长度1-64，只包含字母、数字、下划线、中横线）
     * 注：这里设备端中中文占3个字节
     * @param {*} value
     */
  isDevname (value) {
    // eslint-disable-next-line
      return /^[a-zA-Z0-9_\-]{1,31}$/.test(value)
  },
  /**
     * 昵称格式校验（长度1-32位，只包含数字、字母、汉字、小括号、下划线、中划线、&、点、引号、逗号）
     * @param {*} value
     */
  isNickname (value) {
    return /^[\/a-zA-Z0-9()（）“”""_\-\u4e00-\u9fa5\s\.\,，。‘’《》<>&—]{2,64}$/.test(value)
  },
  // isNicknameEn (value) {
  //   return /^[a-zA-Z0-9()_\u4e00-\u9fa5\s\.\,]{2,64}$/.test(value)
  // },
  /**
     * ip地址校验
     * @param {*} value
     */
  isIpAddress (value) {
    if (value === '') {
      return false
    } else if (value.length > 63) {
      return false
    } else {
      return /^((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d)(\.(((25|0)[0-5])|((2|0)[0-4]\d)|((1|0)\d\d)|([0-9]\d)|\d)){3}$|^([a-zA-Z0-9]([a-zA-Z0-9]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/.test(
        value
      )
    }
  },
  /**
     * 搜索框输入内容，值允许汉字字母数字下划线
     * @param {*} value
     */
  isNormalChar (value) {
    return /^[\/a-zA-Z0-9()（）“”""_\-\u4e00-\u9fa5\s\.\,，。‘’《》<>&—]+$/.test(value)
  },
  /**
     * 设备配置页面，网络连接配置，端口校验
     * @param {*} value
     */
  isPort (value) {
    if (
      /^[0-9]*$/.test(value) &&
        parseInt(value) <= 65535 &&
        parseInt(value) > 0
    ) {
      return true
    } else if (value === '') {
      return false
    } else {
      return false
    }
  },
  /**
     * 设备配置页面，经度校验
     * @param {*} value
     */
  longitude (value) {
    if (value === '0' || value === 0) {
      return true
    } else if (
      /^[+-]?\d+(.[0-9]{1,6})?$/.test(value) &&
        Math.ceil(Math.abs(value)) >= 0 &&
        Math.ceil(Math.abs(value)) <= 180
    ) {
      return true
    } else {
      return false
    }
  },
  /**
     * 设备配置页面，纬度校验
     * @param {*} value
     */
  latitude (value) {
    if (value === '0' || value === 0) {
      return true
    } else if (
      /^[+-]?\d+(.[0-9]{1,6})?$/.test(value) &&
        Math.ceil(Math.abs(value)) >= 0 &&
        Math.ceil(Math.abs(value)) <= 90
    ) {
      return true
    } else {
      return false
    }
  },
  /**
     * 输入是否有汉字校验
     * @param {*} value
     */
  isChinese (value) {
    return /[\u4E00-\u9FA5]/g.test(value)
  },
  isHexFor8AndSpace (value) {
    return /^[a-fA-F0-9]{2}( [a-fA-F0-9]{2})?( [a-fA-F0-9]{2})?( [a-fA-F0-9]{2})?( [a-fA-F0-9]{2})?( [a-fA-F0-9]{2})?( [a-fA-F0-9]{2})?( [a-fA-F0-9]{2})?$/.test(value)
  },
  devtypeName (value) {
    return /^[a-z0-9_-]{1,31}$/.test(value)
  },
  isSupplierCode (value) {
    return /^[0-9a-zA-Z]{2,64}$/.test(value)
  }
}
export default validate



// WEBPACK FOOTER //
// ./third_party/common_app/Common/ZWSUtils/validate.js